import React from "react"

import {FormattedMessage} from "@irati/utils/lang"
import {OrganisationalSummaryCategory} from "@irati/types"
import {Body} from "@irati/ui/src/Typography"
import {TrendTypes} from "./enums"

export const getOpenModalButtonText = (selectedTrendRate: TrendTypes) => {
  if (selectedTrendRate === TrendTypes.engagementRate) {
    return "admin.reporting.orgSummary.modal.openModalText.engagementRate"
  }
  if (selectedTrendRate === TrendTypes.engagements || selectedTrendRate === TrendTypes.interactions) {
    return "admin.reporting.orgSummary.modal.openModalText.interactions"
  }
  if (selectedTrendRate === TrendTypes.savings) {
    return "admin.reporting.orgSummary.modal.openModalText.savings"
  }
}

export const getModalTitle = (selectedTrendRate: TrendTypes, selectedCategory: OrganisationalSummaryCategory) => {
  if (selectedTrendRate === TrendTypes.engagements) {
    return "admin.reporting.orgSummary.modal.modalTitle.interactions"
  }
  if (selectedCategory === OrganisationalSummaryCategory.Main) {
    if (selectedTrendRate === TrendTypes.engagementRate) {
      return "admin.reporting.orgSummary.modal.modalTitle.engagementRate"
    }

    if (selectedTrendRate === TrendTypes.savings) {
      return "admin.reporting.orgSummary.modal.modalTitle.savings"
    }
  }
  if (selectedCategory === OrganisationalSummaryCategory.Perks) {
    if (selectedTrendRate === TrendTypes.engagementRate) {
      return "admin.reporting.orgSummary.modal.modalTitle.perkEngagementRate"
    }
  }
  if (selectedCategory === OrganisationalSummaryCategory.Celebrations) {
    if (selectedTrendRate === TrendTypes.engagementRate) {
      return "admin.reporting.orgSummary.modal.modalTitle.celebrationsEngagementRate"
    }
    if (selectedTrendRate === TrendTypes.interactions) {
      return "admin.reporting.orgSummary.modal.modalTitle.interactions"
    }
  }
  if (selectedCategory === OrganisationalSummaryCategory.Wellness) {
    if (selectedTrendRate === TrendTypes.engagementRate) {
      return "admin.reporting.orgSummary.modal.modalTitle.wellnessEngagementRate"
    }
  }
}

export const getModalImg = (selectedTrendRate: TrendTypes) => {
  if (selectedTrendRate === TrendTypes.engagementRate) {
    return "admin.reporting.trendReports.modal.img.engagement"
  }
  if (selectedTrendRate === TrendTypes.engagements || selectedTrendRate === TrendTypes.interactions) {
    return "admin.reporting.trendReports.modal.img.interactions"
  }
  if (selectedTrendRate === TrendTypes.savings) {
    return "admin.reporting.trendReports.modal.img.savings"
  }
}

export const getModalText = (selectedTrendRate: TrendTypes, selectedCategory: OrganisationalSummaryCategory) => {
  if (selectedCategory === OrganisationalSummaryCategory.Main) {
    if (selectedTrendRate === TrendTypes.engagementRate) {
      return (
        <FormattedMessage
          id="admin.reporting.orgSummary.modal.main.engagementRate.text"
          values={{
            bold1: (
              <Body weight="bold" display="inline">
                <FormattedMessage id="admin.reporting.orgSummary.modal.main.engagementRate.bold1" />
              </Body>
            ),
            bold2: (
              <Body weight="bold" display="inline">
                <FormattedMessage id="admin.reporting.orgSummary.modal.main.engagementRate.bold2" />
              </Body>
            )
          }}
        />
      )
    }
    if (selectedTrendRate === TrendTypes.engagements) {
      return (
        <>
          <Body weight="bold">
            <FormattedMessage id="admin.reporting.orgSummary.modal.main.engagements.text" />
          </Body>
          <Body>
            <FormattedMessage
              id="admin.reporting.orgSummary.modal.main.engagements.text1"
              values={{
                bold: (
                  <Body weight="bold" display="inline">
                    <FormattedMessage id="admin.reporting.orgSummary.modal.main.engagements.bold1" />
                  </Body>
                )
              }}
            />
          </Body>
          <Body>
            <FormattedMessage
              id="admin.reporting.orgSummary.modal.main.engagements.text2"
              values={{
                bold: (
                  <Body weight="bold" display="inline">
                    <FormattedMessage id="admin.reporting.orgSummary.modal.main.engagements.bold2" />
                  </Body>
                )
              }}
            />
          </Body>
          <Body>
            <FormattedMessage
              id="admin.reporting.orgSummary.modal.main.engagements.text3"
              values={{
                bold: (
                  <Body weight="bold" display="inline">
                    <FormattedMessage id="admin.reporting.orgSummary.modal.main.engagements.bold3" />
                  </Body>
                )
              }}
            />
          </Body>
          <Body>
            <FormattedMessage
              id="admin.reporting.orgSummary.modal.main.engagements.text4"
              values={{
                bold: (
                  <Body weight="bold" display="inline">
                    <FormattedMessage id="admin.reporting.orgSummary.modal.main.engagements.bold4" />
                  </Body>
                )
              }}
            />
          </Body>
          <Body>
            <FormattedMessage
              id="admin.reporting.orgSummary.modal.main.engagements.text5"
              values={{
                bold: (
                  <Body weight="bold" display="inline">
                    <FormattedMessage id="admin.reporting.orgSummary.modal.main.engagements.bold5" />
                  </Body>
                )
              }}
            />
          </Body>
        </>
      )
    }
    if (selectedTrendRate === TrendTypes.savings) {
      return (
        <>
          <Body weight="bold">
            <FormattedMessage id="admin.reporting.orgSummary.modal.main.savings.text" />
          </Body>
          <Body>
            <FormattedMessage
              id="admin.reporting.orgSummary.modal.main.savings.text1"
              values={{
                bold: (
                  <Body weight="bold" display="inline">
                    <FormattedMessage id="admin.reporting.orgSummary.modal.main.savings.bold1" />
                  </Body>
                )
              }}
            />
          </Body>
          <Body>
            <FormattedMessage
              id="admin.reporting.orgSummary.modal.main.savings.text2"
              values={{
                bold: (
                  <Body weight="bold" display="inline">
                    <FormattedMessage id="admin.reporting.orgSummary.modal.main.savings.bold2" />
                  </Body>
                )
              }}
            />
          </Body>
        </>
      )
    }
  }
  if (selectedCategory === OrganisationalSummaryCategory.Perks) {
    if (selectedTrendRate === TrendTypes.engagementRate) {
      return (
        <>
          <Body marginBottom={1}>
            <FormattedMessage
              id="admin.reporting.orgSummary.modal.perks.engagementRate.text1"
              values={{
                bold: (
                  <Body weight="bold" display="inline">
                    <FormattedMessage id="admin.reporting.orgSummary.modal.perks.engagementRate.bold1" />
                  </Body>
                )
              }}
            />
          </Body>
          <Body>
            <FormattedMessage id="admin.reporting.orgSummary.modal.perks.engagementRate.text2" />
          </Body>
          <Body>
            <FormattedMessage id="admin.reporting.orgSummary.modal.perks.engagementRate.text3" />
          </Body>
          <Body marginTop={1}>
            <FormattedMessage
              id="admin.reporting.orgSummary.modal.perks.engagementRate.text4"
              values={{
                bold: (
                  <Body weight="bold" display="inline">
                    <FormattedMessage id="admin.reporting.orgSummary.modal.perks.engagementRate.bold4" />
                  </Body>
                )
              }}
            />
          </Body>
        </>
      )
    }
  }
  if (selectedCategory === OrganisationalSummaryCategory.Celebrations) {
    if (selectedTrendRate === TrendTypes.engagementRate) {
      return (
        <>
          <Body marginBottom={1}>
            <FormattedMessage
              id="admin.reporting.orgSummary.modal.celebration.text"
              values={{
                bold: (
                  <Body weight="bold" display="inline">
                    <FormattedMessage id="admin.reporting.orgSummary.modal.celebration.bold" />
                  </Body>
                )
              }}
            />
          </Body>
          <Body>
            <FormattedMessage id="admin.reporting.orgSummary.modal.celebration.text1" />
          </Body>
          <Body>
            <FormattedMessage id="admin.reporting.orgSummary.modal.celebration.text2" />
          </Body>
          <Body>
            <FormattedMessage id="admin.reporting.orgSummary.modal.celebration.text3" />
          </Body>
          <Body marginTop={1}>
            <FormattedMessage
              id="admin.reporting.orgSummary.modal.celebration.text4"
              values={{
                bold: (
                  <Body weight="bold" display="inline">
                    <FormattedMessage id="admin.reporting.orgSummary.modal.celebration.bold4" />
                  </Body>
                )
              }}
            />
          </Body>
        </>
      )
    }
    if (selectedTrendRate === TrendTypes.interactions) {
      return (
        <>
          <Body weight="bold" marginBottom={1}>
            <FormattedMessage id="admin.reporting.orgSummary.modal.celebration.interations.bold" />
          </Body>
          <Body>
            <FormattedMessage id="admin.reporting.orgSummary.modal.celebration.interations.text1" />
          </Body>
          <Body>
            <FormattedMessage id="admin.reporting.orgSummary.modal.celebration.interations.text2" />
          </Body>
          <Body>
            <FormattedMessage id="admin.reporting.orgSummary.modal.celebration.interations.text3" />
          </Body>
        </>
      )
    }
  }
  if (selectedCategory === OrganisationalSummaryCategory.Wellness) {
    if (selectedTrendRate === TrendTypes.engagementRate) {
      return (
        <>
          <Body marginBottom={1}>
            <FormattedMessage
              id="admin.reporting.orgSummary.modal.wellness.engagementRate.text1"
              values={{
                bold: (
                  <Body weight="bold" display="inline">
                    <FormattedMessage id="admin.reporting.orgSummary.modal.wellness.engagementRate.bold1" />
                  </Body>
                )
              }}
            />
          </Body>
          <Body>
            <FormattedMessage id="admin.reporting.orgSummary.modal.wellness.engagementRate.text2" />
          </Body>
          <Body>
            <FormattedMessage id="admin.reporting.orgSummary.modal.wellness.engagementRate.text3" />
          </Body>
          <Body marginTop={1}>
            <FormattedMessage
              id="admin.reporting.orgSummary.modal.wellness.engagementRate.text4"
              values={{
                bold: (
                  <Body weight="bold" display="inline">
                    <FormattedMessage id="admin.reporting.orgSummary.modal.wellness.engagementRate.bold4" />
                  </Body>
                )
              }}
            />
          </Body>
        </>
      )
    }
  }
}
